import React, { useState } from 'react'
import { createStory } from '../../actions/userActions'
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from "react-router-dom";
import CreateStory from '../../containers/Home/CreateStory/CreateStory';

const CreateNewStory = ({ setIsVisibleNewStory,refStory }) => {

    const dispatch = useDispatch();
    const {isLoadingCreateStory} = useSelector(state=>state.userInfo)
    const history = useHistory()

    const [files, setFiles] = useState({});

    const handleCreateStory = async () => {
        const formData = new FormData();
        if(files?.file){
            formData.append('files', files.file)
            dispatch(createStory(formData, history,setIsVisibleNewStory))
        }
      
      //  setIsVisibleNewStory(false)
    }

    const onFileChange = (event) => {
        var filesTarget = event.target.files
        var img = {}
        var video = {}
        for (let i = 0; i < filesTarget.length; i++) {
            if (filesTarget[i].type.includes('image')) {
                img[i] = new Image()
                img[i].onload = (imgs) => {
                    filesTarget[i].url = URL.createObjectURL(filesTarget[i])
                    setFiles({ type: filesTarget[i].type, height: img[i].naturalHeight, width: img[i].naturalWidth, url: filesTarget[i].url, file: filesTarget[i] })
                }
                img[i].src = URL.createObjectURL(filesTarget[i])
            }
            if (filesTarget[i].type.includes('video')) {
                video[i] = document.createElement("video");
                video[i].onloadeddata = (imgs) => {
                    filesTarget[i].url = URL.createObjectURL(filesTarget[i])

                    setFiles({ type: filesTarget[i].type, height: video[i].videoHeight, width: video[i].videoWidth, url: filesTarget[i].url, file: filesTarget[i] })
                }
                video[i].src = URL.createObjectURL(filesTarget[i])
            }
        }
        console.log()
    }
    return (
        <CreateStory isLoadingCreateStory={isLoadingCreateStory} refStory={refStory} createStory={handleCreateStory} onFileChange={onFileChange} file={files.url} type={files.type} />
    )
}

export default CreateNewStory
